export default {"src":"/_next/static/media/flightio.76b52e9e.svg","height":54,"width":200,"blurWidth":0,"blurHeight":0};